export default {
  //TODO: FIND BETTER PARAM NAMES
  deepCopy(oldObject, newObject) {
    let keys = Object.getOwnPropertyNames(newObject);
    for (let i = 0; i < keys.length; i++) {
      let newObjectValue = newObject[keys[i]];
      if (typeof newObjectValue !== "object") {
        oldObject[keys[i]] = newObjectValue;
      }
    }
  },

  convertPublishModelToUpdateModel(entities) {
    entities.forEach((entity, index) => {
      if (entity.intents === null) return;
      if (entity.intents[0].type === "UPDATE_ZONE") {
        let entityTemp = {};
        entityTemp = JSON.parse(entity.intents[0].model);
        entityTemp.intents = [];
        entityTemp.intentId = entity.intents[0].id;
        entityTemp.intents.push(entity.intents[0]);
        entities[index] = entityTemp;
      }
    });
    return entities;
  },
};
